import BrandItemPersonalArea from './BrandItemPersonalArea';

export default BrandItemPersonalArea;
